module.exports = __webpack_public_path__ + "img/jinhangyoulun.9526eef5.png";